import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import detector from "i18next-browser-languagedetector";
// import Backend from "i18next-http-backend";

import koTranslations from './ko-KR/ko.json';
import enTranslations from './en-US/en.json';

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    lng: 'ko',
    resources: {
      ko: { translation: koTranslations },
      en: { translation: enTranslations }
    },
    fallbackLng: "ko",
    detection: {
      order: ['querystring', 'localStorage', 'cookie', 'navigator', 'htmlTag'],
      lookupQueryString: 'lang',
      lookupLocalStorage: 'lang',
      lookupCookie: 'i18n_lang',
      caches: ['localStorage', 'cookie']
    },
    debug: false,
    saveMissing: true,
    interpolation: {
      escapeValue: false
    }
  }, (err) => {
    if (err) console.error(err);
  });

export default i18n;


